import { Stack } from "@mui/material";
import PropTypes from "prop-types";
import { SiteDetails } from "react-common-ui-library";

const SiteDetailsDisplay = ({ siteList }) => {
  return (
    <Stack spacing={3}>
      {siteList.map((siteLocation, index) => {
        return (
          <SiteDetails
            key={siteLocation.providerSiteLocationId}
            businessName={siteLocation.businessName}
            serviceAddressLine1={siteLocation.serviceAddressLine1}
            serviceAddressLine2={siteLocation.serviceAddressLine2}
            city={siteLocation.city}
            state={siteLocation.state}
            zip={siteLocation.zip}
            npiId={siteLocation.npiId}
            siteDetailsId={index}
            isLocationDetailsPage
          />
        );
      })}
    </Stack>
  );
};

SiteDetailsDisplay.propTypes = {
  siteList: PropTypes.array.isRequired,
};

export default SiteDetailsDisplay;
